import type { StockAlertsReport } from '@sellokart/shared';
import { portalApi, queryString } from '@/lib/api';

/** The till's own "expiring soon" look-ahead. */
export const DEFAULT_EXPIRY_DAYS = 30;

/** A snapshot: keyed on branch and look-ahead only — no date range applies. */
export const stockAlertsKeys = {
  report: (branchId: string, days: number) => ['reports', 'stock-alerts', branchId, days] as const,
};

export function fetchStockAlerts(
  branchId: string,
  days: number = DEFAULT_EXPIRY_DAYS,
  signal?: AbortSignal,
): Promise<StockAlertsReport> {
  const query = queryString({ branchId: branchId || undefined, days });
  return portalApi.get<StockAlertsReport>(`/portal/reports/stock-alerts${query}`, { signal });
}
